import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const OfferHeaderImage = () => {
  const data = useStaticQuery(graphql`
    query {
      OfferHeaderImage: file(
        relativePath: { eq: "platform/offers/offer-header.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.OfferHeaderImage.childImageSharp.fluid}
      alt="Offer Header Image"
    />
  )
}

export default OfferHeaderImage
